import type React from "react";
import { AppRoutes } from "@/router/routes";

export const App: React.FC = () => {
	return (
		<div className="min-h-screen bg-background text-foreground">
			<AppRoutes />
		</div>
	);
};
